import { createContext } from 'react';
export var TableSortableContext = /*#__PURE__*/createContext({});
export var TableSortableProvider = TableSortableContext.Provider;